import React from 'react';
import { useTranslation } from '@shared/core';
import { LinkV2 } from '@withjoy/joykit';

export const TermsOfServiceLink = () => {
  const { t } = useTranslation('createWedding');

  return (
    <LinkV2
      typographyVariant="label1"
      isExternal
      href="https://withjoy.com/eula/"
      fontSize="inherit"
      color="gray8"
    >
      {t('createAccount', 'termsOfService')()}
    </LinkV2>
  );
};
